'use strict';

/* globals define, config, ajaxify, Image */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/course/course', [
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-video/static/vendor/videojs/video.js',
	'translator',
	'benchpress',
	'courseViewer',
], function (vue, videojs, translator, Benchpress, courseViewer) {
	var	Course = {};

	Course.init = function () {
		courseViewer.init(ajaxify.data.course, ajaxify.data.group, ajaxify.data.translations);

		videoThumbnailsPreload(ajaxify.data.course.trainers);
		videoThumbnailsPreload(ajaxify.data.course.chapters);
		chapterImagesPreload();
	};

	function videoThumbnailsPreload(videosContainer) {
		for (let i = 0; i < videosContainer.length; i++) {
			var videoContainer = videosContainer[i];

			if (videoContainer.videoThumbnail) {
				preloadImage(videoContainer.videoThumbnail);
			}
		}
	}

	function chapterImagesPreload() {
		for (let i = 0; i < ajaxify.data.course.chapters.length; i++) {
			var chapter = ajaxify.data.course.chapters[i];

			if (chapter.footerImage) {
				preloadImage(chapter.footerImage);
			}
		}
	}

	function preloadImage(url) {
		const img = new Image();
		img.src = url;
		return img;
	}

	return Course;
});
